import map from 'lodash/map';
import union from 'lodash/union';

import { AppSettingsModule } from 'services/settings.provider';
import { SubscriptionServiceModule } from 'services/access/subscription/subscription.service';
import { DataServiceModule } from './data.service';
import { SearchServiceModule } from './search.service';
import { StoreInformationServiceModule } from './storeInformation.service';

export const ImagesServiceModule = angular
    .module('app.services.data.imagesService', [
        DataServiceModule,
        AppSettingsModule,
        SearchServiceModule,
        StoreInformationServiceModule,
        SubscriptionServiceModule
    ]).service('imagesService', (
        dataService,
        settings,
        $q,
        searchService,
        subscriptionsService
    ) => {
        let saveImage = (image) => {
            return dataService.create(settings.api.images, {
                file: image
            });
        };

        let saveImages = (images) => {
            let promises = map(images, (image) => {
                return saveImage(image);
            });
            return $q.all(promises).then(data => data);
        };

        let populateImageLibraryFromIndustry = (industry) => {
            return dataService.save(settings.api.populateLibrary, industry);
        };

        let updateImage = (image) => {
            return dataService.save(settings.api.images, image.id, image);
        };

        let updateTags = (images, tagsToAdd) => {
            let promises = map(images, (image) => {
                image.tags = union(image.tags, tagsToAdd);
                return updateImage(image);
            });
            return $q.all(promises).then(data => data);
        };

        let create = (image) => {
            return dataService.create(settings.api.images, image);
        };

        let removeImage = (image) => {
            return dataService.remove(settings.api.images, image.id);
        };

        let removeImages = (images) => {
            let promises = map(images, (image) => {
                return removeImage(image);
            });
            return $q.all(promises);
        };

        let getImage = (id) => {
            return dataService.get(settings.api.images, id);
        };

        let getImages = (page, count, sort, options) => {
            options = options || {};
            page = page || 1;
            count = count || 12;

            options.pagesize = count;
            options.startindex = (page - 1) * count;

            if (sort && sort.length) {
                options.sortby = sort[0].replace(' ', '+');
            }

            return dataService.getAll(settings.api.images, options);
        };

        let getImageLinks = () => {
            return dataService.getAll(settings.api.imageLinks);
        };

        let buildAlgoliaTagString = (tags) => {
            let tagString = '';
            if (tags.length > 0) {
                tagString += '(';
                angular.forEach(tags, (tag, key) => {
                    tagString += tag;
                    if (key < tags.length - 1) {
                        tagString += ',';
                    }
                });
                tagString += ')';
            }
            return tagString;
        };

        let getImagesFromAlgolia = (tags, page, count) => {
            return searchService.search(
                'imagelinks',
                null,
                {
                    tagFilters: buildAlgoliaTagString(tags),
                    hitsPerPage: count,
                    page: page
                },
                false
            ).then(data => data);
        };

        function getImageLimit() {
            return subscriptionsService.getSubscription().then(subscription => subscription.features.imageLimit);
        }

        return {
            saveImage,
            saveImages,
            create,
            getImage,
            getImages,
            getImagesFromAlgolia,
            removeImage,
            removeImages,
            updateImage,
            updateTags,
            getImageLimit,
            populateImageLibraryFromIndustry,
            getImageLinks
        };
    }).name;



// WEBPACK FOOTER //
// ./src/app/services/data/images.service.js